import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import OtherOption from '../OtherOption';
import { dispatchOptionField } from '../../../../Util/Util';

const CheckboxInput = (props) => {
	const { t, i18n } = useTranslation();
	const dispatch = useDispatch();

	const {form_component, option, checkedValues, formFields} = props;
	const {fieldname, has_other_options, option_display} = form_component;

	const cbFieldData = useSelector(state => state.cbFieldData);
	const optionFields = useSelector(state => state.optionFields);
	const curStep = useSelector(state => state.curStep);
	const jumpHistory = useSelector(state => state.jumpHistory) || [];

	const onChange = (e) => {
		const { checked, value } = e.target;

		if (option_display !== 'OW') {
			//console.log(`value`, value, 'checked', checked);

			var payload = {...cbFieldData};
			if (typeof payload[fieldname] === 'undefined') {
				payload[fieldname] = [];
			}

			if (checked) {
				payload[fieldname].push(value);
			} else {
				const index = payload[fieldname].indexOf(value);
				if (index > -1) {
					payload[fieldname].splice(index, 1);
				}
			}

			dispatch({type: 'SET_CBFIELD_DATA', payload: payload});
		}

		const allCheckedValues = checkedValues.join(',');
		dispatchOptionField(
			dispatch, 
			form_component, 
			allCheckedValues, 
			optionFields, 
			curStep, 
			formFields.form_components, 
			option,
			jumpHistory
		);
	};

	return (
		<>
		<input
			className={`form-check-input ${has_other_options ? 'has-other' : ''}`}
			type="checkbox"
			name={`${fieldname}[]`}
			id={`${fieldname}-${option.value}`}
			value={option.value}
			checked={checkedValues.indexOf(option.value) >= 0}
			onChange={onChange}
		/>
		<label className="form-check-label" htmlFor={`${fieldname}-${option.value}`}>
			<div className="d-flex gap-3 opt">
				<div className="x-checkbox"></div>
				<div className="ans">
					{option.value !== 'other' ? (
						<p className="mb-0">{option.label}</p>
					) : (
						<OtherOption
							key={`input-other`}
							lang={props.lang}
							form_component={form_component}
							checkedValue={checkedValues.indexOf('other') >= 0 ? 'other' : ''}
						/>
					)}
					<div className="pic w-100">
						
					</div>
				</div>
			</div>
		</label>
		</>
	);
}

export default CheckboxInput;